import React, { useRef, useState } from "react"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import DialogTitle from "@mui/material/DialogTitle"
import useMediaQuery from "@mui/material/useMediaQuery"
import { useTheme } from "@mui/material/styles"
import styled from "@emotion/styled"

const StyledConfirmDialog = styled(Dialog)`
  .MuiPaper-root {
    width: min(540px, calc(100vw - 30px));
    border-radius: 18px;
    border: 1px solid var(--cms-border);
    background: var(--cms-dialog-bg);
    box-shadow: 0 20px 46px rgba(15, 23, 42, 0.2);
  }

  .MuiDialogTitle-root {
    padding: 18px 22px 8px;
    font-size: 20px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .MuiDialogContent-root {
    padding: 8px 22px 10px;
  }

  .MuiDialogContentText-root {
    color: var(--cms-text-primary);
    font-size: 14px;
    line-height: 1.55;
  }

  .MuiDialogActions-root {
    padding: 8px 22px 20px;
    gap: 10px;
  }

  .dialog-disagree-btn {
    text-transform: none;
    font-weight: 700;
    color: var(--cms-text-secondary);
  }

  .dialog-agree-btn {
    text-transform: none;
    font-weight: 700;
    border-radius: 10px;
    padding: 8px 16px;
    box-shadow: 0 12px 24px rgba(239, 68, 68, 0.26);
    background: linear-gradient(170deg, #ef4444 0%, #dc2626 100%);
  }
`

const UseConfirmDialog = ({ title, description, agreeText, disagreeText }) => {
  const [open, setOpen] = React.useState(false)
  const [customDescription, setCustomDescription] = useState(null)
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"))

  const callbackAction = useRef(null)

  const openDialog = (callback, customDesc) => {
    callbackAction.current = callback
    setCustomDescription(customDesc)
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    setCustomDescription(null)
  }

  const handleAgree = () => {
    if (callbackAction.current) {
      callbackAction.current()
    }
    setOpen(false)
  }

  const ConfirmDialog = (
    <StyledConfirmDialog
      fullScreen={fullScreen}
      open={open}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle id="responsive-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {customDescription ? customDescription : description}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button className="dialog-disagree-btn" autoFocus onClick={handleClose}>
          {disagreeText || "Disagree"}
        </Button>
        <Button
          variant="contained"
          className="dialog-agree-btn"
          onClick={handleAgree}
          autoFocus
        >
          {agreeText || "Agree"}
        </Button>
      </DialogActions>
    </StyledConfirmDialog>
  )

  return [ConfirmDialog, openDialog]
}

export default UseConfirmDialog
